import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class ProductService {
  static productCreate = async (bodyFormData) => {

    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/products/create",
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static productDetailsSearch = async (rowsPerPage, page, searchTerm, publisher, subject, medium, category, grade) => {
    try {
      let filter = [];

          if (searchTerm) {
            filter.push({'keyword': searchTerm})
          }
          if(publisher){
            filter.push({'publisherId': publisher})
          }
          if(subject){
            filter.push({'subjectId': subject})
          }
          if(medium){
            filter.push({'mediumId': medium})
          }
          if(category){
            filter.push({'level3catId': category})
          }
          if(grade){
            filter.push({'grade': grade})
          }
        
 

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/products/admin/search",
        data: {
          filter: filter,
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static categoryProductsSearch = async (categoryId, rowsPerPage, page) => {
    try {

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/products/admin/search",
        data: {
          filter: [{level3catId: categoryId }],
          limit: rowsPerPage,
          skip: page * rowsPerPage,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static productDetailsAllSearch = async (filterColumns) => {
    try {
      let filter = [];

      if (filterColumns.length > 0) {
        filterColumns.map((column)=> {
          filter.push(column);
        })
        
      }
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/products/admin/search",
        data: {
          filter: filter,
          limit: 5000,
          skip: 0,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static activeProductDetailsSearch = async (filterData) => {
    try {
      let filter = [];
      if(filterData.length > 0){
        filterData.map((column)=> {
          filter.push(column);
          })
      }

      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/products/admin/search",
        data: {
          filter: filter,
          limit: 5000,
          skip: 0,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static groupProductDetailsSearch = async () => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/products/admin/search",
        data: {
          filter: [{"product_group_type": "single"}, {"status": "ACTIVE"}, {"stock": "instock"}],
          limit: 5000,
          skip: 0,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productDetail = response.data.data;
      return productDetail;
    } catch (err) {
      throw err;
    }
  };

  static productDetailsID = async (productID) => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/products/admin/" + productID,
        headers: { Authorization: `Bearer ${authToken}` },
      });

      let orderDetailID = response.data.data;

      return orderDetailID;
    } catch (err) {
      throw err;
    }
  };

  static productDelete = async (productID) => {
    try {
      let response = await axios({
        method: "delete",
        baseURL: API_ORIGIN + "/products/" + productID,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static productUpdate = async (productID, bodydata) => {
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/products/update/" + productID,
        data: bodydata,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static groupProductUpdate = async (productID, bodydata) => {
    const groupData = bodydata;
    try {
      let response = await axios({
        method: "put",
        baseURL: API_ORIGIN + "/products/group/update/" + productID,
        data: groupData,
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let responseData = response.data.data;

      return responseData;
    } catch (err) {
      throw err;
    }
  };

  static popularproductDetails = async () => {
    try {
      let response = await axios({
        method: "post",
        baseURL: API_ORIGIN + "/products/popular",
        data: {
          filter: [],
          limit: 20,
          skip: 0,
          sort: "DESC",
        },
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let popularproductDetail = response.data.data.results;

      return popularproductDetail;
    } catch (err) {
      throw err;
    }
  };

  static allproductsNames = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/products/view/all/names",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      let productsDetail = response.data.data.allProducts;

      return productsDetail;
    } catch (err) {
      throw err;
    }
  };

}
